import { Flex } from "@chakra-ui/react";

import { RanaTable } from "@nens/ranalib";

import { FoldersBreadcrumb } from "@/components/folders-breadcrumb";
import { TableEmptyFiles } from "@/components/table-empty-file";
import { useProjectFiles } from "@/hooks/use-project-files";
import { RanaFileIcon } from "@/lib/rana-file-data-type";
import { fileNameColumnString } from "@/translations";
import { getNameFromFileId } from "@/utils/get-name-from-file-id";

type SchematisationProjectImportModalFromCatalogueDirectoryProps = {
  passUpPath: (path: string) => void;
};

export function SchematisationProjectImportModalFromCatalogueDirectory({
  passUpPath,
}: SchematisationProjectImportModalFromCatalogueDirectoryProps) {
  const {
    path,
    paths,
    setPaths,

    intl,
    files,
    tableDataIds,
    isLoading,
    onDirectoryOrFileClick,
    clearFile,
  } = useProjectFiles({});

  passUpPath(path);

  return (
    <>
      <Flex justifyContent="space-between" w="full">
        <FoldersBreadcrumb
          paths={paths}
          setPaths={(paths) => {
            setPaths(paths);
            clearFile();
          }}
          isViewingFolder
        />
      </Flex>

      <RanaTable
        columnDefinitions={[
          {
            width: "table_cell_m",
            title: fileNameColumnString(intl),
          },
        ]}
        tableDataIds={tableDataIds}
        emptyElement={<TableEmptyFiles />}
        isSkeleton={isLoading}
      >
        <RanaTable.Container mt={4}>
          <RanaTable.Body>
            {files.map((fileOrDirectory) => {
              const { id, type } = fileOrDirectory;
              const name = getNameFromFileId(id);

              const isNotAccepted = type === "file";

              return (
                <RanaTable.Row
                  _hover={{ textDecor: "underline" }}
                  cursor="pointer"
                  onClick={() => {
                    clearFile();
                    onDirectoryOrFileClick(fileOrDirectory);
                  }}
                  key={id}
                  rowId={id}
                  title={
                    isNotAccepted
                      ? intl.formatMessage({
                          id: "schematisation.import_modal_directory_only",
                          defaultMessage: "This is just a directory picker",
                        })
                      : undefined
                  }
                  isDisabled={isNotAccepted}
                >
                  <RanaTable.Cell title={name}>
                    <RanaFileIcon fileOrDirectory={fileOrDirectory} />
                    {name}
                  </RanaTable.Cell>
                </RanaTable.Row>
              );
            })}
          </RanaTable.Body>
        </RanaTable.Container>
      </RanaTable>
    </>
  );
}
